<template>
    <section class="col-xs-12 col-sm-5">
        <div class="calendar__info">
            <div class="calendar__info__item">
                <h4 class="calendar__info__title">{{ $t('FIRST_PERIOD_DAY') }}</h4>
                <div class="calendar__info__date__wrapper">
                    <div class="calendar__info__date">
                        <span>{{ firstPeriodDay | moment('dd') }}</span>
                        <span class="date__day-number">{{ firstPeriodDay | moment('DD') }}</span>
                    </div>
                    <div class="calendar__info__month">
                        <span>{{ firstPeriodDay | moment('MMM') }} {{ firstPeriodDay | moment('YYYY') }}</span>
                    </div>
                </div>

                <div class="radio__wrapper">
                    <v-radio-group v-model="isFirstPeriodDay" class="input-date-wrapper">
                        <v-radio :label="$t('YES')" color="main-color" value="yes"></v-radio>
                    </v-radio-group>
                    <v-radio-group v-model="isFirstPeriodDay" class="input-date-wrapper">
                        <v-radio :label="$t('NO')" color="main-color" value="no"></v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="calendar__info__item">
                <div class="next-examination__wrapper">
                    <h4 class="calendar__info__title --no-border mb-1">{{ $t('CYCLE_LENGTH') }}</h4>
                    <div class="row">
                        <div class="col-xs-6">
                            <el-select v-model="periodLength" :placeholder="$t('SELECT')">
                                <el-option
                                    v-for="item in selectPeriodLength"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6">
                            <button
                                @click.stop="confirmFirstPeriodDay"
                                class="app-btn app-btn--big app-btn-primary --wild mt-3"
                            >
                                {{ $t('APPLY') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
var moment = require('moment');
export default {
    props: {
        firstPeriodDay: String,
        isFirstPeriodDay: String,
        periodLength: String,
        select1: Array,
    },
    data() {
        return {
            isFirstPeriodDay: null,
            periodLength: null,
            selectPeriodLength: [
                {
                    value: '25',
                    label: '25',
                },
                {
                    value: '26',
                    label: '26',
                },
                {
                    value: '27',
                    label: '27',
                },
                {
                    value: '28',
                    label: '28',
                },
                {
                    value: '29',
                    label: '29',
                },
                {
                    value: '30',
                    label: '30',
                },
                {
                    value: '31',
                    label: '31',
                },
                {
                    value: '32',
                    label: '32',
                },
                {
                    value: '33',
                    label: '33',
                },
            ],
        };
    },
    methods: {
        confirmFirstPeriodDay() {
            this.$emit('confirmFirstPeriodDay');
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// first-period-day.vue?1719663b